// extracted by mini-css-extract-plugin
export default {"island":"island--ySh6Q","padding":"padding--JtZBk"};